import React, { Component } from 'react';
import './login.scss';
import axios from 'axios';
import { userService } from '../../../Services/User.Service';
import { Form, Icon, Input, Button, Checkbox, message} from 'antd';
import { FormComponentProps } from 'antd/es/form';
import loginIcon from '../../../Assets/icons/password.svg';
import seoIcon from '../../../Assets/icons/seo.svg';
import {authService} from "../../../Services/Public/cognito-auth";
import { Link } from 'react-router-dom';
interface UserFormProps extends FormComponentProps {
  age: number;
  name: string;
}
const formItemLayout = {
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
};
 class login extends Component<any, any> {
   state = {
     loading: false,
   };
  componentDidMount() {
    let UserData = localStorage.getItem('UserData')   ;

    if (UserData !== null) {
        debugger

        const email=JSON.parse(UserData).email;
        axios
            .get(`${'https://8i9s27h4vl.execute-api.us-west-2.amazonaws.com/dev/'}merchant?group=${'brand'}&email=${email}`)

            .then(profile => {
                this.setState({  loading: false });
                this.setState({ isAuthenticated: true });


                if (profile) {
                    const { from } = this.props.location.state || {
                        from: { pathname: '/panel/search' }
                    };
                    this.props.history.push(from);
                    localStorage.setItem('UserData', JSON.stringify(profile.data));

                }

            })
            .catch(error => {
                this.setState({ isAuthenticated: false });
                this.setState({  loading: false });
            });

    } else {
      this.setState({ isAuthenticated: true });
    }
  }
  constructor(props: any) {
    super(props);

    userService.logout();
  }

  handleSubmit = (e:any) => {
    e.preventDefault();
    this.props.form.validateFields((err:any, values:any )=> {
      if (!err) {
        console.log('Received values of form: ', values);
        this.setState({  loading: true });


          authService.login(values.Email,values.Password,(success:any) => {
              this.setState({  loading: false });
              if (success) {

                  localStorage.setItem('TokenLimit', success.accessToken.jwtToken);
                  this.setState({  loading: true });
                  debugger
                  axios
                      .get(`${'https://8i9s27h4vl.execute-api.us-west-2.amazonaws.com/dev/'}merchant?group=${'brand'}&email=${values.Email}`)

                      .then(profile => {
                          this.setState({  loading: false });



                          if (profile) {
                              message.success(' Welcome ');

                                let host =window.location.origin;
                                window.location.replace(host+"/panel/search");



                              localStorage.setItem('UserData', JSON.stringify(profile.data));
                              localStorage.setItem('Token', success.accessToken.jwtToken);
                          }

                      })
                      .catch(error => {
                          this.setState({  loading: false });
                      });


              }
          }, (error :any) => {
              this.setState({ error, loading: false });
              // message.error(error);
              if(error.code=='UserNotConfirmedException'){
                  message.error(error.message);
              }
              else if(error.code=='NotAuthorizedException'){
                  message.error(error.message);
              }
             else {
                  message.error(' Invalid username or password! ');
              }
          });

        //   userService.login(values.username, values.password).then(
        //     user => {
        //       const { from } = this.props.location.state || {
        //         from: { pathname: '/panel/search' }
        //       };
        //       message.success(' خوش آمدید ');
        //       this.props.history.push(from);
        //       this.setState({  loading: false });
        //     },
        //     error =>{
        //       this.setState({ error, loading: false });
        //       // message.error(error);
        //         message.error(' نام کاربری یا رمز عبور اشتباه می باشد! ');
        //     }
        // );
      }
    });
  };

  render() {

    const { getFieldDecorator } = this.props.form;
    return (
      <div className="loginContainer">
        <div className="loginForm">
          <div className="logo">
            <img src={loginIcon} alt="" />
          </div>


          <Form {...formItemLayout} onSubmit={this.handleSubmit} className="login-form" >
            <Form.Item>
              {getFieldDecorator('Email', {
                rules: [{ required: true, message: 'Please enter your email!' }],
              })(
                  <Input
                      prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      placeholder="Email"
                  />,
              )}
            </Form.Item>
            <Form.Item >
              {getFieldDecorator('Password', {
                rules: [{ required: true,  message: 'Please enter your password!' }],
              })(
                  <Input.Password
                      prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                      type="password"
                      placeholder="Password"
                  />,
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('remember', {
                valuePropName: 'checked',
                initialValue: true,
              })(<Checkbox>remember me</Checkbox>)}

          
              <Link className="login-form-forgot" to="/forgetpassword" style={{ color: '#1890ff' }}>
                  Forgot your password ?
              </Link>
              <Button type="primary" loading={this.state.loading} htmlType="submit" className="login-form-button">
                Login
              </Button>
               Or
               <Link to={'/register'} style={{ color: '#1890ff' }}>
               Register now!  
               </Link>
        
            </Form.Item>
          </Form>

        </div>
          <div className="loginBg" >

                  <img src={seoIcon} alt="" />

          </div>
      </div>
    );

  }
}
export default Form.create<UserFormProps>({
  // ...
})(login);
